import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import { State } from '../state'

/**
 * Clears duplicate detection state after the employee edit workflow completes.
 */
export const resetOnEditingComplete = store.reducers.extra(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    new store.reducers.ExtraReducer({
      on: [
        plugin.collection.plugins.editingPlugin.feature.actions.submit.success,
        plugin.collection.plugins.editingPlugin.feature.actions.discard.success,
      ],
      reduce: () => State.INITIAL,
    }),
)
